export type HeightTypes = typeof heights;

export const heights = {
	header: '8.6rem',
	headerHover: '27.8rem',
	headerMobile: '6.4rem',
};
